import * as React from "react";
import { cn } from "@/lib/utils";

export interface TaskpanePanelShellProps {
  children: React.ReactNode;
  /** scroll: default vertical scroll. flex: column flex for nested min-h-0 scroll regions. */
  variant?: "scroll" | "flex";
  className?: string;
}

/**
 * Shared outer wrapper for task pane modules (Knowledge, Templates, Blocks, Variables).
 */
export function TaskpanePanelShell({
  children,
  variant = "scroll",
  className,
}: TaskpanePanelShellProps) {
  return (
    <div
      className={cn(
        "h-full min-h-0 bg-slate-50",
        variant === "scroll" ? "overflow-auto p-6" : "flex min-h-0 flex-col overflow-hidden p-6",
        className
      )}
    >
      {children}
    </div>
  );
}
